module.exports = __webpack_public_path__ + "img/img_12.a1874eef.jpg";